import { render, staticRenderFns } from "./CustomsDeclarationDialog.vue?vue&type=template&id=4e5efbd0&scoped=true"
import script from "./CustomsDeclarationDialog.vue?vue&type=script&lang=ts"
export * from "./CustomsDeclarationDialog.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e5efbd0",
  null
  
)

export default component.exports